export default __webpack_public_path__ + "static/media/hht2_ep_17.f771e818.png";